/*
 * Azullado – Real User Monitoring
 * Erfasst LCP, INP, CLS, FCP und TTFB.
 */
(function () {
  "use strict";

  if (window.__azulladoRumLoaded) {
    return;
  }

  window.__azulladoRumLoaded = true;

  var RUM_SAMPLE_RATE = 1;
  var rumStarted = false;
  var privacyApiRequested = false;

  var WEB_VITALS_URL =
    "https://unpkg.com/web-vitals@5/dist/" +
    "web-vitals.attribution.iife.js";

  function cleanText(
    value,
    maximumLength
  ) {
    var limit =
      maximumLength || 180;

    if (
      value === null ||
      value === undefined
    ) {
      return "";
    }

    return String(value)
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, limit);
  }

  function canPublish() {
    return Boolean(
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify
        .analytics.publish ===
        "function"
    );
  }

  function analyticsAllowed() {
    return Boolean(
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify
        .customerPrivacy
        .analyticsProcessingAllowed ===
        "function" &&
      window.Shopify
        .customerPrivacy
        .analyticsProcessingAllowed()
    );
  }

  function getPageType() {
    var path =
      window.location.pathname;

    if (path === "/") {
      return "home";
    }

    if (
      path.indexOf(
        "/products/"
      ) === 0
    ) {
      return "product";
    }

    if (
      path.indexOf(
        "/collections/"
      ) === 0
    ) {
      return "collection";
    }

    if (
      /^\/cart\/?$/.test(path)
    ) {
      return "cart";
    }

    if (
      path.indexOf(
        "/search"
      ) === 0
    ) {
      return "search";
    }

    return "other";
  }

  function getConnectionType() {
    var connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (!connection) {
      return "";
    }

    return cleanText(
      connection.effectiveType,
      20
    );
  }

  function getAttributionTarget(
    metric
  ) {
    var attribution =
      metric.attribution || {};

    return cleanText(
      attribution.target ||
      attribution.interactionTarget ||
      attribution.largestShiftTarget ||
      "",
      180
    );
  }

  function normalizeValue(
    metricName,
    value
  ) {
    var numericValue =
      Number(value);

    if (
      !Number.isFinite(
        numericValue
      )
    ) {
      return null;
    }

    if (
      metricName === "CLS"
    ) {
      return (
        Math.round(
          numericValue * 10000
        ) / 10000
      );
    }

    return Math.round(
      numericValue
    );
  }

  function reportMetric(metric) {
    if (
      !analyticsAllowed() ||
      !canPublish()
    ) {
      return;
    }

    var metricValue =
      normalizeValue(
        metric.name,
        metric.value
      );

    if (metricValue === null) {
      return;
    }

    var metricDelta =
      normalizeValue(
        metric.name,
        metric.delta
      );

    window.Shopify.analytics.publish(
      "azullado:web_vital",
      {
        metric_name:
          cleanText(
            metric.name,
            20
          ),

        metric_value:
          metricValue,

        metric_delta:
          metricDelta,

        metric_rating:
          cleanText(
            metric.rating,
            40
          ),

        metric_id:
          cleanText(
            metric.id,
            100
          ),

        navigation_type:
          cleanText(
            metric.navigationType,
            60
          ),

        attribution_target:
          getAttributionTarget(
            metric
          ),

        page_type:
          getPageType(),

        page_path:
          cleanText(
            window.location.pathname,
            300
          ),

        viewport_width:
          window.innerWidth || null,

        viewport_height:
          window.innerHeight || null,

        connection_type:
          getConnectionType(),

        timestamp:
          new Date().toISOString()
      }
    );
  }

  function registerWebVitals() {
    if (
      !window.webVitals
    ) {
      return;
    }

    /*
     * In Produktion keine Zwischenstände
     * versenden, sondern nur berichtsfertige
     * Messwerte.
     */
    var options = {
      reportAllChanges: false
    };

    window.webVitals.onCLS(
      reportMetric,
      options
    );

    window.webVitals.onINP(
      reportMetric,
      options
    );

    window.webVitals.onLCP(
      reportMetric,
      options
    );

    window.webVitals.onFCP(
      reportMetric,
      options
    );

    window.webVitals.onTTFB(
      reportMetric,
      options
    );
  }

  function loadWebVitals() {
    if (
      window.webVitals
    ) {
      registerWebVitals();
      return;
    }

    var script =
      document.createElement(
        "script"
      );

    script.src =
      WEB_VITALS_URL;

    script.async = true;

    script.onload =
      function () {
        registerWebVitals();
      };

    script.onerror =
      function () {
        /*
         * Ein Ladefehler darf den Shop
         * nicht beeinflussen.
         */
      };

    document.head.appendChild(
      script
    );
  }

  function startRum() {
    if (
      rumStarted ||
      !analyticsAllowed()
    ) {
      return;
    }

    if (
      Math.random() >
      RUM_SAMPLE_RATE
    ) {
      rumStarted = true;
      return;
    }

    rumStarted = true;
    loadWebVitals();
  }

  function requestPrivacyApi(
    attempt
  ) {
    if (
      privacyApiRequested
    ) {
      return;
    }

    if (
      window.Shopify &&
      typeof window.Shopify
        .loadFeatures ===
        "function"
    ) {
      privacyApiRequested = true;

      window.Shopify.loadFeatures(
        [
          {
            name:
              "consent-tracking-api",
            version: "0.1"
          }
        ],
        function (error) {
          if (!error) {
            startRum();
          }
        }
      );

      return;
    }

    if (attempt < 40) {
      window.setTimeout(
        function () {
          requestPrivacyApi(
            attempt + 1
          );
        },
        250
      );
    }
  }

  document.addEventListener(
    "visitorConsentCollected",
    function (event) {
      var detail =
        event.detail || {};

      if (
        detail.analyticsAllowed ===
        true
      ) {
        startRum();
      }
    }
  );

  requestPrivacyApi(0);
})();